webpackJsonp([20],{

/***/ 1040:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageSelectAudio_vue__ = __webpack_require__(944);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84f00c98_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imageSelectAudio_vue__ = __webpack_require__(1047);
function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageSelectAudio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84f00c98_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imageSelectAudio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1042);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("0f646eac", content, true, {});

/***/ }),

/***/ 1042:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".align-center{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@-webkit-keyframes loadAudioPlayer{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@keyframes loadAudioPlayer{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@-webkit-keyframes loadAudioPlayerReset{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}@keyframes loadAudioPlayerReset{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}.animationLoadCircle{-webkit-animation-name:loadAudioPlayer;animation-name:loadAudioPlayer;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.animationLoadCircle.reset{animation-direction:reverse;-webkit-animation-duration:.5s;animation-duration:.5s}.select-question .select-question__left{margin-right:20px}@media (max-width:980px){.select-question{-ms-flex-wrap:wrap;flex-wrap:wrap}.select-question .select-question__left{margin-right:0;margin-bottom:20px}}.image{width:100%;background:#ddd;border-radius:20px;overflow:hidden}.select-question__item{background:#d5d5d5;border-radius:30px;padding:6.5px;-webkit-transition:.3s;transition:.3s;cursor:pointer}.select-question__item .index{width:30px;height:30px;min-width:30px;border-radius:50%;background:#a2a2a2;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#fff;margin-right:10px}.select-question__item:hover{background:#626262;color:#fff}.select-question__item.clicked{background:#3bbfd4;color:#fff}.select-question__item.correct{background:#5ec12d;color:#fff}.select-question__item.correct .index{color:#366e1a;background:#98df75}.select-question__item.wrong{background:#c2003c}.select-question__item.wrong .index{color:#5c001c;background:#ff296b}.select-question__item.clicked .index{color:#1e7c8b;background:#8fdae6}.select-question__right .select-question__item{margin-bottom:20px}.correct_result,.wrong_result{font-weight:700}.correct_result{color:#5ec12d!important}.wrong_result{color:#c2003c!important}.block__game{width:100%;height:100%;position:absolute;top:0;left:0;z-index:10}.vue-sound-wrapper{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#009bff;border-radius:30px;margin-top:20px;height:42px}.vue-sound-wrapper,.vue-sound-wrapper .vue-sound__player{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.vue-sound-wrapper .vue-sound__player{width:100%;padding:5px;margin:0 auto}.vue-sound-wrapper .vue-sound__player .vue-sound__extern-wrapper,.vue-sound-wrapper .vue-sound__player .vue-sound__playback-time-current,.vue-sound-wrapper .vue-sound__player .vue-sound__playback-time-separator,.vue-sound-wrapper .vue-sound__player .vue-sound__playback-time-total{display:none!important}.vue-sound-wrapper .vue-sound__player .vue-sound__playback-time-wrapper{background:#00d4ff!important}.vue-sound-wrapper .vue-sound__player .vue-sound__playback-time-indicator{background:#fff!important}.vue-sound-wrapper .vue-sound__playback-time-wrapper{width:100%!important}.vue-sound-wrapper .vue-sound__player{padding-right:20px;-webkit-box-sizing:border-box;box-sizing:border-box}.vue-sound-wrapper .vue-sound__player a{margin-right:15px;width:33px;min-width:33px;height:33px;background:#fff;border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.vue-sound-wrapper .icon-stop2{display:none!important}.icon-pause2,.icon-play3,.icon-stop2{position:relative}.icon-pause2:before,.icon-play3:before,.icon-stop2:before{position:absolute;top:9px;left:9px;color:#009bff}.select_question{margin-bottom:20px}.select_question p{color:#610000;font-weight:300;font-size:16px}.select_question .img{width:57px;min-width:57px;height:57px;background:#ff9c00;border-radius:10px;margin-right:10px}.select_question-red .img{background:#c2003c}.select-question_answer-select-question .image{min-height:310px}.select-question_answer-select-question .image img{-o-object-fit:cover;object-fit:cover;height:310px}div #test .select-question_answer-select-question .image{min-height:15px}.block__game .answer:last-child{margin-bottom:0}.answer{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;-ms-flex-line-pack:center;align-content:center;margin-bottom:16px}.answer__player{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.answer__select__icon{cursor:pointer;-ms-flex-item-align:end;align-self:flex-end;background-color:#ddd;border-radius:150px;font-size:30px;font-weight:600;text-align:center;vertical-align:middle;line-height:42px;margin-left:10px}.answer__select__icon,.answer__select__icon img{width:42px;height:42px}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/game/imageSelectAudio.vue"],"names":[],"mappings":"AACA,cACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,mCACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,2BACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,wCACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,gCACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,qBACE,uCAAwC,AAChC,+BAAgC,AACxC,qCAAsC,AAC9B,4BAA8B,CACvC,AACD,2BACI,4BAA6B,AAC7B,+BAAgC,AACxB,sBAAwB,CACnC,AACD,wCACE,iBAAmB,CACpB,AACD,yBACA,iBACI,mBAAoB,AAChB,cAAgB,CACvB,AACD,wCACM,eAAgB,AAChB,kBAAoB,CACzB,CACA,AACD,OACE,WAAY,AACZ,gBAAiB,AACjB,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,mBAAoB,AACpB,mBAAoB,AACpB,cAAe,AACf,uBAAyB,AACzB,eAAiB,AACjB,cAAgB,CACjB,AACD,8BACI,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,kBAAmB,AACnB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAe,AACf,iBAAmB,CACtB,AACD,6BACI,mBAAoB,AACpB,UAAe,CAClB,AACD,+BACI,mBAAoB,AACpB,UAAe,CAClB,AACD,+BACI,mBAAoB,AACpB,UAAe,CAClB,AACD,sCACM,cAAe,AACf,kBAAoB,CACzB,AACD,6BACI,kBAAoB,CACvB,AACD,oCACM,cAAe,AACf,kBAAoB,CACzB,AACD,sCACI,cAAe,AACf,kBAAoB,CACvB,AACD,+CACE,kBAAoB,CACrB,AACD,8BAEE,eAAkB,CACnB,AACD,gBACE,uBAA0B,CAC3B,AACD,cACE,uBAA0B,CAC3B,AACD,aACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,UAAY,CACb,AACD,mBAOE,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mBAAoB,AACpB,mBAAoB,AACpB,gBAAiB,AACjB,WAAa,CACd,AACD,yDAdE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAmB7B,AAVD,sCACI,WAAY,AACZ,YAAa,AACb,aAAe,CAOlB,AACD,yRAIM,sBAAyB,CAC9B,AACD,wEACM,4BAA+B,CACpC,AACD,0EACM,yBAA+B,CACpC,AACD,qDACI,oBAAuB,CAC1B,AACD,sCACI,mBAAoB,AACpB,8BAA+B,AACvB,qBAAuB,CAClC,AACD,wCACM,kBAAmB,AACnB,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,gBAAoB,AACpB,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACjC,AACD,+BACI,sBAAyB,CAC5B,AACD,qCAGE,iBAAmB,CACpB,AACD,0DAGI,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,aAAe,CAClB,AACD,iBACE,kBAAoB,CACrB,AACD,mBACI,cAAe,AACf,gBAAiB,AACjB,cAAgB,CACnB,AACD,sBACI,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,mBAAoB,AACpB,mBAAoB,AACpB,iBAAmB,CACtB,AACD,0BACI,kBAAoB,CACvB,AACD,+CACE,gBAAkB,CACnB,AACD,mDACI,oBAAqB,AAClB,iBAAkB,AACrB,YAAc,CACjB,AACD,yDACE,eAAiB,CAClB,AACD,gCACE,eAAiB,CAClB,AACD,QACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,6BAA8B,AAClC,0BAA2B,AACvB,qBAAsB,AAC1B,kBAAoB,CACrB,AACD,gBACI,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CACxB,AACD,sBACI,eAAgB,AAChB,wBAAyB,AACrB,oBAAqB,AACzB,sBAAuB,AAGvB,oBAAqB,AACrB,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,sBAAuB,AACvB,iBAAkB,AAClB,gBAAkB,CACrB,AACD,gDAVI,WAAY,AACZ,WAAa,CAYhB","file":"imageSelectAudio.vue","sourcesContent":["\n.align-center {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@-webkit-keyframes loadAudioPlayer {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@keyframes loadAudioPlayer {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@-webkit-keyframes loadAudioPlayerReset {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n@keyframes loadAudioPlayerReset {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n.animationLoadCircle {\n  -webkit-animation-name: loadAudioPlayer;\n          animation-name: loadAudioPlayer;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n}\n.animationLoadCircle.reset {\n    animation-direction: reverse;\n    -webkit-animation-duration: .5s;\n            animation-duration: .5s;\n}\n.select-question .select-question__left {\n  margin-right: 20px;\n}\n@media (max-width: 980px) {\n.select-question {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.select-question .select-question__left {\n      margin-right: 0;\n      margin-bottom: 20px;\n}\n}\n.image {\n  width: 100%;\n  background: #ddd;\n  border-radius: 20px;\n  overflow: hidden;\n}\n.select-question__item {\n  background: #D5D5D5;\n  border-radius: 30px;\n  padding: 6.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  cursor: pointer;\n}\n.select-question__item .index {\n    width: 30px;\n    height: 30px;\n    min-width: 30px;\n    border-radius: 50%;\n    background: #a2a2a2;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    color: #ffffff;\n    margin-right: 10px;\n}\n.select-question__item:hover {\n    background: #626262;\n    color: #ffffff;\n}\n.select-question__item.clicked {\n    background: #3BBFD4;\n    color: #ffffff;\n}\n.select-question__item.correct {\n    background: #5EC12D;\n    color: #ffffff;\n}\n.select-question__item.correct .index {\n      color: #366e1a;\n      background: #98df75;\n}\n.select-question__item.wrong {\n    background: #C2003C;\n}\n.select-question__item.wrong .index {\n      color: #5c001c;\n      background: #ff296b;\n}\n.select-question__item.clicked .index {\n    color: #1e7c8b;\n    background: #8fdae6;\n}\n.select-question__right .select-question__item {\n  margin-bottom: 20px;\n}\n.correct_result,\n.wrong_result {\n  font-weight: bold;\n}\n.correct_result {\n  color: #5EC12D !important;\n}\n.wrong_result {\n  color: #C2003C !important;\n}\n.block__game {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n.vue-sound-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background: #009BFF;\n  border-radius: 30px;\n  margin-top: 20px;\n  height: 42px;\n}\n.vue-sound-wrapper .vue-sound__player {\n    width: 100%;\n    padding: 5px;\n    margin: 0 auto;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.vue-sound-wrapper .vue-sound__player .vue-sound__extern-wrapper,\n    .vue-sound-wrapper .vue-sound__player .vue-sound__playback-time-current,\n    .vue-sound-wrapper .vue-sound__player .vue-sound__playback-time-separator,\n    .vue-sound-wrapper .vue-sound__player .vue-sound__playback-time-total {\n      display: none !important;\n}\n.vue-sound-wrapper .vue-sound__player .vue-sound__playback-time-wrapper {\n      background: #00D4FF !important;\n}\n.vue-sound-wrapper .vue-sound__player .vue-sound__playback-time-indicator {\n      background: #ffffff !important;\n}\n.vue-sound-wrapper .vue-sound__playback-time-wrapper {\n    width: 100% !important;\n}\n.vue-sound-wrapper .vue-sound__player {\n    padding-right: 20px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n.vue-sound-wrapper .vue-sound__player a {\n      margin-right: 15px;\n      width: 33px;\n      min-width: 33px;\n      height: 33px;\n      background: #ffffff;\n      border-radius: 50%;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.vue-sound-wrapper .icon-stop2 {\n    display: none !important;\n}\n.icon-pause2,\n.icon-play3,\n.icon-stop2 {\n  position: relative;\n}\n.icon-pause2:before,\n  .icon-play3:before,\n  .icon-stop2:before {\n    position: absolute;\n    top: 9px;\n    left: 9px;\n    color: #009BFF;\n}\n.select_question {\n  margin-bottom: 20px;\n}\n.select_question p {\n    color: #610000;\n    font-weight: 300;\n    font-size: 16px;\n}\n.select_question .img {\n    width: 57px;\n    min-width: 57px;\n    height: 57px;\n    background: #FF9C00;\n    border-radius: 10px;\n    margin-right: 10px;\n}\n.select_question-red .img {\n    background: #C2003C;\n}\n.select-question_answer-select-question .image {\n  min-height: 310px;\n}\n.select-question_answer-select-question .image img {\n    -o-object-fit: cover;\n       object-fit: cover;\n    height: 310px;\n}\ndiv #test .select-question_answer-select-question .image {\n  min-height: 15px;\n}\n.block__game .answer:last-child {\n  margin-bottom: 0;\n}\n.answer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  margin-bottom: 16px;\n}\n.answer__player {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n}\n.answer__select__icon {\n    cursor: pointer;\n    -ms-flex-item-align: end;\n        align-self: flex-end;\n    background-color: #ddd;\n    width: 42px;\n    height: 42px;\n    border-radius: 150px;\n    font-size: 30px;\n    font-weight: 600;\n    text-align: center;\n    vertical-align: middle;\n    line-height: 42px;\n    margin-left: 10px;\n}\n.answer__select__icon img {\n      width: 42px;\n      height: 42px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1043:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_audio_player_select_audio_vue__ = __webpack_require__(945);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_215bae54_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_audio_player_select_audio_vue__ = __webpack_require__(1046);
function injectStyle (ssrContext) {
  __webpack_require__(1044)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-215bae54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_audio_player_select_audio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_215bae54_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_audio_player_select_audio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1044:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1045);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("19ade2f6", content, true, {});

/***/ }),

/***/ 1045:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".align-center[data-v-215bae54]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@-webkit-keyframes loadAudioPlayer-data-v-215bae54{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@keyframes loadAudioPlayer-data-v-215bae54{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@-webkit-keyframes loadAudioPlayerReset-data-v-215bae54{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}@keyframes loadAudioPlayerReset-data-v-215bae54{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}.animationLoadCircle[data-v-215bae54]{-webkit-animation-name:loadAudioPlayer-data-v-215bae54;animation-name:loadAudioPlayer-data-v-215bae54;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.animationLoadCircle.reset[data-v-215bae54]{animation-direction:reverse;-webkit-animation-duration:.5s;animation-duration:.5s}.select-audio[data-v-215bae54]{background:#d8d8d8;border-radius:50px}.select-audio .checkbox[data-v-215bae54],.select-audio .index[data-v-215bae54]{border:1px solid #979797;background:#afafaf;color:#fff;width:30px;min-width:30px;height:30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:50%;margin:0 10px;-webkit-box-sizing:border-box;box-sizing:border-box}.select-audio .checkbox[data-v-215bae54]{border:3px solid #b7b7b7;background:#fff;margin-left:0;cursor:pointer}.select-audio .checkbox[data-v-215bae54]:hover{color:#f4f4f4}.select-audio.right[data-v-215bae54]{background:#dffb6c}.select-audio.right .index[data-v-215bae54]{border:1px solid #79940d;background:#abc92e;color:#7e9a10}.select-audio.right .checkbox[data-v-215bae54]{border-color:#7e9a10}.select-audio.wrong[data-v-215bae54]{background:#f5004c}.select-audio.wrong .index[data-v-215bae54]{border:1px solid #d62727;background:#eb8787;color:#9c0404}.select-audio.wrong .checkbox[data-v-215bae54]{border-color:#d62727}.select-audio .player[data-v-215bae54]{background:#009bff;border-radius:50px;padding:8px;width:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.player-control[data-v-215bae54]{width:30px;height:30px;border-radius:50%;-webkit-transition:.3s;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;cursor:pointer;border:none;transition:.3s;margin-right:8px;background:transparent}.player-control[data-v-215bae54]:hover{-webkit-transform:scale(1.1);transform:scale(1.1)}.player-control.player-controls-restart[data-v-215bae54]{width:25px;height:25px}.player-control[data-v-215bae54]:active{background:#2b0872}.player-time[data-v-215bae54]{width:55px;text-align:right;padding-right:8px}.player-time span[data-v-215bae54]{font-size:14px;color:#fff}.player-progress[data-v-215bae54]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.player-progress-bg[data-v-215bae54]{height:10px;border-radius:20px;width:100%;background:hsla(0,0%,100%,.5);overflow:hidden}.player-progress-current[data-v-215bae54]{-webkit-transition:width .2s;transition:width .2s;background:#510cd8;height:10px;border-radius:20px;-webkit-animation-timing-function:linear;animation-timing-function:linear;-webkit-animation-fill-mode:backwards;animation-fill-mode:backwards}@-webkit-keyframes progressAudio-data-v-215bae54{0%{width:0}to{width:100%}}@keyframes progressAudio-data-v-215bae54{0%{width:0}to{width:100%}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/game/GameComponents/audio-player-select-audio.vue"],"names":[],"mappings":"AACA,+BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,mDACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,2CACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,wDACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,gDACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,sCACE,uDAAwD,AAChD,+CAAgD,AACxD,qCAAsC,AAC9B,4BAA8B,CACvC,AACD,4CACI,4BAA6B,AAC7B,+BAAgC,AACxB,sBAAwB,CACnC,AACD,+BACE,mBAAoB,AACpB,kBAAoB,CACrB,AACD,+EAEI,yBAA0B,AAC1B,mBAAoB,AACpB,WAAY,AACZ,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,cAAe,AACf,8BAA+B,AACvB,qBAAuB,CAClC,AACD,yCACI,yBAA0B,AAC1B,gBAAiB,AACjB,cAAe,AACf,cAAgB,CACnB,AACD,+CACM,aAAe,CACpB,AACD,qCACI,kBAAoB,CACvB,AACD,4CACM,yBAA0B,AAC1B,mBAAoB,AACpB,aAAe,CACpB,AACD,+CACM,oBAAsB,CAC3B,AACD,qCACI,kBAAoB,CACvB,AACD,4CACM,yBAA0B,AAC1B,mBAAoB,AACpB,aAAe,CACpB,AACD,+CACM,oBAAsB,CAC3B,AACD,uCACI,mBAAoB,AAEpB,mBAAoB,AACpB,YAAa,AACb,WAAY,AACZ,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CACxB,AACD,iCACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,uBAAyB,AAEzB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,eAAiB,AACjB,iBAAkB,AAClB,sBAAwB,CACzB,AACD,uCACI,6BAAmC,AAC3B,oBAA2B,CACtC,AACD,yDACI,WAAY,AACZ,WAAa,CAChB,AACD,wCACI,kBAAoB,CACvB,AACD,8BACE,WAAY,AACZ,iBAAkB,AAClB,iBAAmB,CACpB,AACD,mCACI,eAAgB,AAChB,UAAY,CACf,AACD,kCACE,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CACtB,AACD,qCACE,YAAa,AACb,mBAAoB,AACpB,WAAY,AACZ,8BAAqC,AACrC,eAAiB,CAClB,AACD,0CACE,6BAA+B,AAC/B,qBAAuB,AACvB,mBAAoB,AACpB,YAAa,AACb,mBAAoB,AACpB,yCAA0C,AAClC,iCAAkC,AAC1C,sCAAuC,AAC/B,6BAA+B,CACxC,AACD,iDACA,GACI,OAAS,CACZ,AACD,GACI,UAAY,CACf,CACA,AACD,yCACA,GACI,OAAS,CACZ,AACD,GACI,UAAY,CACf,CACA","file":"audio-player-select-audio.vue","sourcesContent":["\n.align-center[data-v-215bae54] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@-webkit-keyframes loadAudioPlayer-data-v-215bae54 {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@keyframes loadAudioPlayer-data-v-215bae54 {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@-webkit-keyframes loadAudioPlayerReset-data-v-215bae54 {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n@keyframes loadAudioPlayerReset-data-v-215bae54 {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n.animationLoadCircle[data-v-215bae54] {\n  -webkit-animation-name: loadAudioPlayer-data-v-215bae54;\n          animation-name: loadAudioPlayer-data-v-215bae54;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n}\n.animationLoadCircle.reset[data-v-215bae54] {\n    animation-direction: reverse;\n    -webkit-animation-duration: .5s;\n            animation-duration: .5s;\n}\n.select-audio[data-v-215bae54] {\n  background: #d8d8d8;\n  border-radius: 50px;\n}\n.select-audio .index[data-v-215bae54],\n  .select-audio .checkbox[data-v-215bae54] {\n    border: 1px solid #979797;\n    background: #afafaf;\n    color: #fff;\n    width: 30px;\n    min-width: 30px;\n    height: 30px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 50%;\n    margin: 0 10px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n.select-audio .checkbox[data-v-215bae54] {\n    border: 3px solid #b7b7b7;\n    background: #fff;\n    margin-left: 0;\n    cursor: pointer;\n}\n.select-audio .checkbox[data-v-215bae54]:hover {\n      color: #f4f4f4;\n}\n.select-audio.right[data-v-215bae54] {\n    background: #dffb6c;\n}\n.select-audio.right .index[data-v-215bae54] {\n      border: 1px solid #79940d;\n      background: #abc92e;\n      color: #7e9a10;\n}\n.select-audio.right .checkbox[data-v-215bae54] {\n      border-color: #7e9a10;\n}\n.select-audio.wrong[data-v-215bae54] {\n    background: #f5004c;\n}\n.select-audio.wrong .index[data-v-215bae54] {\n      border: 1px solid #d62727;\n      background: #eb8787;\n      color: #9c0404;\n}\n.select-audio.wrong .checkbox[data-v-215bae54] {\n      border-color: #d62727;\n}\n.select-audio .player[data-v-215bae54] {\n    background: #009BFF;\n    padding: 8px;\n    border-radius: 50px;\n    padding: 8px;\n    width: 100%;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n}\n.player-control[data-v-215bae54] {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-align: center;\n  cursor: pointer;\n  border: none;\n  transition: 0.3s;\n  margin-right: 8px;\n  background: transparent;\n}\n.player-control[data-v-215bae54]:hover {\n    -webkit-transform: scale(1.1, 1.1);\n            transform: scale(1.1, 1.1);\n}\n.player-control.player-controls-restart[data-v-215bae54] {\n    width: 25px;\n    height: 25px;\n}\n.player-control[data-v-215bae54]:active {\n    background: #2b0872;\n}\n.player-time[data-v-215bae54] {\n  width: 55px;\n  text-align: right;\n  padding-right: 8px;\n}\n.player-time span[data-v-215bae54] {\n    font-size: 14px;\n    color: #fff;\n}\n.player-progress[data-v-215bae54] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.player-progress-bg[data-v-215bae54] {\n  height: 10px;\n  border-radius: 20px;\n  width: 100%;\n  background: rgba(255, 255, 255, 0.5);\n  overflow: hidden;\n}\n.player-progress-current[data-v-215bae54] {\n  -webkit-transition: width 0.2s;\n  transition: width 0.2s;\n  background: #510cd8;\n  height: 10px;\n  border-radius: 20px;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  -webkit-animation-fill-mode: backwards;\n          animation-fill-mode: backwards;\n}\n@-webkit-keyframes progressAudio-data-v-215bae54 {\nfrom {\n    width: 0;\n}\nto {\n    width: 100%;\n}\n}\n@keyframes progressAudio-data-v-215bae54 {\nfrom {\n    width: 0;\n}\nto {\n    width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1046:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-audio container align-center",class:{ right: _vm.answered && _vm.correct, wrong: _vm.answered && !_vm.correct}},[_c('div',{staticClass:"index",on:{"click":function($event){return _vm.select()}}},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('div',{staticClass:"checkbox",on:{"click":function($event){return _vm.select()}}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.answered && _vm.correct),expression:"answered && correct"}],attrs:{"src":__webpack_require__(656),"width":"25","alt":"Right"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.answered && !_vm.correct),expression:"answered && !correct"}],attrs:{"src":__webpack_require__(195),"width":"25","alt":"wrong"}})]),_vm._v(" "),_c('div',{staticClass:"player container align-center"},[_c('audio',{ref:"player",attrs:{"src":_vm.src,"hidden":""},on:{"playing":function($event){_vm.playing = true},"pause":function($event){_vm.playing = false},"loadeddata":function($event){return _vm.loaded($event.target)},"timeupdate":function($event){return _vm.timeChanged($event.target.currentTime)},"ended":function($event){_vm.ended = true}}}),_vm._v(" "),_c('div',{staticClass:"player-controls container align-center"},[_c('button',{staticClass:"player-control",class:{'player-controls-play' : _vm.playing, 'player-controls-pause' : !_vm.playing},on:{"click":function($event){return _vm.toogle()}}},[(_vm.playing)?_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"30","height":"30","viewBox":"0 0 30 30"}},[_c('defs',[_c('clipPath',{attrs:{"id":"b"}},[_c('rect',{attrs:{"width":"30","height":"30"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"a","clip-path":"url(#b)"}},[_c('g',{attrs:{"transform":"translate(-363 -420)"}},[_c('path',{attrs:{"d":"M7.5,2.017a14.994,14.994,0,0,1,21.98,16.866A15.012,15.012,0,0,1,15.024,30a15.09,15.09,0,0,1-3.905-.517A14.994,14.994,0,0,1,7.5,2.017ZM27.975,18.478a13.432,13.432,0,0,0-9.5-16.451,13.512,13.512,0,0,0-3.5-.463A13.437,13.437,0,0,0,3.367,21.718a13.432,13.432,0,0,0,24.607-3.24Z","transform":"translate(363 419.998)","fill":"#003944"}}),_vm._v(" "),_c('path',{attrs:{"d":"M51.729,33.388a13.418,13.418,0,1,1-11.655-6.721,13.514,13.514,0,0,1,3.5.463A13.346,13.346,0,0,1,51.729,33.388Zm-2.555.689a.781.781,0,0,0,.14-1.1,11.774,11.774,0,0,0-7.658-4.422.781.781,0,0,0-.212,1.547,10.2,10.2,0,0,1,6.635,3.83.781.781,0,0,0,1.1.14Z","transform":"translate(337.904 394.895)","fill":"#afd6de"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(373.103 423.448)"}},[_c('path',{attrs:{"d":"M276.024,63.283a.781.781,0,0,1-1.235.956,10.2,10.2,0,0,0-6.635-3.83.781.781,0,0,1,.212-1.547A11.774,11.774,0,0,1,276.024,63.283Z","transform":"translate(-261.91 -58.854)","fill":"#003944"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"translate(0.155)"}},[_c('g',{attrs:{"transform":"translate(362.999 420)"}},[_c('g',{attrs:{"transform":"translate(9.118 10.117)"}},[_c('path',{attrs:{"d":"M159.537,156h-2.912a.571.571,0,0,0-.624.488v8.789a.571.571,0,0,0,.624.488h2.912a.571.571,0,0,0,.624-.488v-8.789A.571.571,0,0,0,159.537,156Z","transform":"translate(-156.001 -156.001)","fill":"#5de4ff"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"translate(8.846 9.629)"}},[_c('path',{attrs:{"d":"M149.669,146H147.1a1.045,1.045,0,0,0-1.1.977v8.789a1.045,1.045,0,0,0,1.1.977h2.568a1.045,1.045,0,0,0,1.1-.977v-8.789A1.045,1.045,0,0,0,149.669,146Zm-2.568,9.766v-8.789h2.568v8.789Z","transform":"translate(-146.001 -146.001)","fill":"#003944"}})])]),_vm._v(" "),_c('g',{attrs:{"transform":"translate(370.999 420)"}},[_c('g',{attrs:{"transform":"translate(9.118 10.117)"}},[_c('path',{attrs:{"d":"M159.537,156h-2.912a.571.571,0,0,0-.624.488v8.789a.571.571,0,0,0,.624.488h2.912a.571.571,0,0,0,.624-.488v-8.789A.571.571,0,0,0,159.537,156Z","transform":"translate(-156.001 -156.001)","fill":"#5de4ff"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"translate(8.846 9.629)"}},[_c('path',{attrs:{"d":"M149.669,146H147.1a1.045,1.045,0,0,0-1.1.977v8.789a1.045,1.045,0,0,0,1.1.977h2.568a1.045,1.045,0,0,0,1.1-.977v-8.789A1.045,1.045,0,0,0,149.669,146Zm-2.568,9.766v-8.789h2.568v8.789Z","transform":"translate(-146.001 -146.001)","fill":"#003944"}})])])])])])])]):_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"30","height":"30","viewBox":"0 0 30 30"}},[_c('defs',[_c('clipPath',{attrs:{"id":"b"}},[_c('rect',{attrs:{"width":"30","height":"30"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"a","clip-path":"url(#b)"}},[_c('g',{attrs:{"transform":"translate(-363 -420)"}},[_c('path',{attrs:{"d":"M7.5,2.017a14.994,14.994,0,0,1,21.98,16.866A15.012,15.012,0,0,1,15.024,30a15.09,15.09,0,0,1-3.905-.517A14.994,14.994,0,0,1,7.5,2.017ZM27.975,18.478a13.432,13.432,0,0,0-9.5-16.451,13.512,13.512,0,0,0-3.5-.463A13.437,13.437,0,0,0,3.367,21.718a13.432,13.432,0,0,0,24.607-3.24Z","transform":"translate(363 419.998)","fill":"#6200e5"}}),_vm._v(" "),_c('path',{attrs:{"d":"M51.729,33.388a13.418,13.418,0,1,1-11.655-6.721,13.514,13.514,0,0,1,3.5.463A13.346,13.346,0,0,1,51.729,33.388Zm-2.555.689a.781.781,0,0,0,.14-1.1,11.774,11.774,0,0,0-7.658-4.422.781.781,0,0,0-.212,1.547,10.2,10.2,0,0,1,6.635,3.83.781.781,0,0,0,1.1.14ZM48.107,40.1a1.616,1.616,0,0,0-.817-1.415l-9.64-5.566A1.634,1.634,0,0,0,35.2,34.539V45.67a1.632,1.632,0,0,0,2.451,1.415l9.64-5.566A1.616,1.616,0,0,0,48.107,40.1Z","transform":"translate(337.904 394.895)","fill":"#9b8ccc"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(373.103 423.448)"}},[_c('path',{attrs:{"d":"M276.024,63.283a.781.781,0,0,1-1.235.956,10.2,10.2,0,0,0-6.635-3.83.781.781,0,0,1,.212-1.547A11.774,11.774,0,0,1,276.024,63.283Z","transform":"translate(-261.91 -58.854)","fill":"#6200e5"}}),_vm._v(" "),_c('path',{attrs:{"d":"M184.511,138.867a1.634,1.634,0,0,1,0,2.829l-9.64,5.566a1.634,1.634,0,0,1-2.451-1.415V134.716a1.634,1.634,0,0,1,2.451-1.415Zm-.745,1.415a.063.063,0,0,0-.036-.062l-9.64-5.566a.075.075,0,0,0-.036-.011.076.076,0,0,0-.037.011.065.065,0,0,0-.037.063v11.131a.065.065,0,0,0,.037.063.068.068,0,0,0,.073,0l9.64-5.567A.063.063,0,0,0,183.766,140.282Z","transform":"translate(-172.419 -128.73)","fill":"#6200e5"}})]),_vm._v(" "),_c('path',{attrs:{"d":"M208.816,165.325a.072.072,0,0,1,0,.125l-9.64,5.566a.068.068,0,0,1-.073,0,.065.065,0,0,1-.037-.063V159.822a.065.065,0,0,1,.037-.063.077.077,0,0,1,.037-.011.075.075,0,0,1,.036.011Z","transform":"translate(175.597 269.612)","fill":"#ffb300"}})])])])])]),_vm._v(" "),_c('button',{staticClass:"player-control player-controls-restart",on:{"click":function($event){return _vm.reset()}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"25","height":"25","viewBox":"0 0 25 25"}},[_c('defs',[_c('clipPath',{attrs:{"id":"b"}},[_c('rect',{attrs:{"width":"25","height":"25"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"a","clip-path":"url(#b)"}},[_c('g',{attrs:{"transform":"translate(-264 -553)"}},[_c('g',{attrs:{"transform":"translate(264 553)"}},[_c('g',{attrs:{"transform":"translate(0.68 0.68)"}},[_c('path',{attrs:{"d":"M11.661,21.672A10.011,10.011,0,1,1,21.672,31.683,10.011,10.011,0,0,1,11.661,21.672ZM21.672,10A11.672,11.672,0,1,0,33.344,21.672,11.672,11.672,0,0,0,21.672,10Z","transform":"translate(-10 -10)","fill":"#f80"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"10.203","cy":"10.203","r":"10.203","transform":"translate(1.469 1.469)","fill":"#fff"}})])]),_vm._v(" "),_c('path',{attrs:{"d":"M12.5,0A12.5,12.5,0,1,0,25,12.5,12.514,12.514,0,0,0,12.5,0Zm0,24.024A11.523,11.523,0,1,1,24.024,12.5,11.537,11.537,0,0,1,12.5,24.024Z","transform":"translate(263.999 553)","fill":"#8e4200"}}),_vm._v(" "),_c('path',{attrs:{"d":"M45.792,35A10.791,10.791,0,1,0,56.583,45.791,10.8,10.8,0,0,0,45.792,35Zm0,20.606a9.815,9.815,0,1,1,9.815-9.815A9.826,9.826,0,0,1,45.792,55.606Z","transform":"translate(230.708 519.709)","fill":"#8e4200"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(267.95 515.323)"}},[_c('path',{attrs:{"d":"M133.545,175.641l-2.752,2.752h1.532a4.454,4.454,0,0,1-7.217,3.5l-1.778,1.779a6.958,6.958,0,0,0,11.5-5.274H136.3Z","transform":"translate(-119.106 -128.289)","fill":"#f80"}}),_vm._v(" "),_c('path',{attrs:{"d":"M118.212,176.036a7.289,7.289,0,0,1-4.763-1.767.342.342,0,0,1-.018-.5l1.778-1.778a.342.342,0,0,1,.455-.026,4.068,4.068,0,0,0,2.548.887,4.12,4.12,0,0,0,4.1-3.771h-1.176a.342.342,0,0,1-.242-.585l2.752-2.752a.342.342,0,0,1,.484,0l2.752,2.752a.342.342,0,0,1-.242.585H125.5a7.3,7.3,0,0,1-7.293,6.958Zm-4.029-2.052a6.616,6.616,0,0,0,10.645-5.248.342.342,0,0,1,.342-.342h.643l-1.925-1.925-1.925,1.925h.706a.342.342,0,0,1,.342.342,4.8,4.8,0,0,1-4.8,4.8,4.739,4.739,0,0,1-2.728-.852Z","transform":"translate(-109.449 -118.632)","fill":"#8e4200"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18.428,52.8a6.958,6.958,0,0,0-6.958,6.958H10l2.752,2.752L15.5,59.762H13.971a4.454,4.454,0,0,1,7.217-3.5l1.778-1.778A6.907,6.907,0,0,0,18.428,52.8Z","transform":"translate(-9.657 -9.659)","fill":"#f80"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.095,53.2a.341.341,0,0,1-.242-.1L.1,50.346a.342.342,0,0,1,.242-.585H1.478a7.248,7.248,0,0,1,2.13-4.82,7.409,7.409,0,0,1,.942-.8.342.342,0,0,1,.4.558,6.72,6.72,0,0,0-.855.723A6.572,6.572,0,0,0,2.155,50.1a.342.342,0,0,1-.342.342H1.17l1.925,1.925L5.02,50.446H4.314a.342.342,0,0,1-.342-.342,4.8,4.8,0,0,1,4.8-4.8,4.739,4.739,0,0,1,2.728.852l1.3-1.3A6.608,6.608,0,0,0,8.77,43.488a6.692,6.692,0,0,0-1.452.159.342.342,0,1,1-.149-.668,7.375,7.375,0,0,1,1.6-.175,7.289,7.289,0,0,1,4.763,1.767.342.342,0,0,1,.018.5L11.773,46.85a.342.342,0,0,1-.455.026A4.068,4.068,0,0,0,8.77,45.99a4.12,4.12,0,0,0-4.1,3.771H5.846a.342.342,0,0,1,.242.585L3.337,53.1A.342.342,0,0,1,3.095,53.2Z","transform":"translate(0 0)","fill":"#8e4200"}}),_vm._v(" "),_c('path',{attrs:{"d":"M165.068,60.047a.342.342,0,0,1-.137-.656l.029-.013a.342.342,0,0,1,.27.629l-.025.011A.342.342,0,0,1,165.068,60.047Z","transform":"translate(-159.084 -15.981)","fill":"#8e4200"}}),_vm._v(" "),_c('path',{attrs:{"d":"M361.192,371.488a.342.342,0,0,1-.241-.585l.01-.01a.342.342,0,1,1,.484.484l-.011.011A.341.341,0,0,1,361.192,371.488Z","transform":"translate(-348.493 -316.759)","fill":"#8e4200"}}),_vm._v(" "),_c('path',{attrs:{"d":"M247.811,393.806a.342.342,0,0,1,0-.685,5.134,5.134,0,0,0,2.8-.823.342.342,0,1,1,.373.575A5.817,5.817,0,0,1,247.811,393.806Z","transform":"translate(-238.994 -337.474)","fill":"#8e4200"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"player-progress"},[_c('div',{staticClass:"player-progress-bg"},[_c('div',{staticClass:"player-progress-current",style:({ width: (_vm.progress + "%"), animationName: _vm.ended ? 'none' : 'progressAudio', animationDuration: (_vm.duration + "s"), animationPlayState: _vm.playing ? 'running' : 'paused' })})])]),_vm._v(" "),_c('div',{staticClass:"player-time"},[_c('span',[_vm._v(_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1047:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"select-question select-question_answer-select-question container"},[_c('div',{staticClass:"select-question__left flex-grow-1 flex-basis-600"},[_c('div',{staticClass:"image animation-bottom container justify-content-center align-content-stretch"},[_c('image-loader',{attrs:{"src":_vm.question.img}})],1)]),_vm._v(" "),_c('div',{staticClass:"select-question__right flex-grow-2 flex-basis-500"},[_c('div',{staticClass:"select_question select_question-red container align-items-stretch"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 bordered-box bordered-box-orange"},[_c('p',[_vm._v(_vm._s(_vm.question.text))])])]),_vm._v(" "),_c('ul',{staticClass:"list-none relative"},[(_vm.finish)?_c('div',{staticClass:"block__game"}):_vm._e(),_vm._v(" "),_vm._l((_vm.question.answers),function(x,ind){return _c('li',{key:(_vm.index + "-answer-" + ind),staticClass:"animation-bottom",style:({animationDelay: (ind / 20) + 's'})},[_c('div',{staticClass:"answer"},[_c('div',{staticClass:"answer__player"},[_c('audio-player-select-audio',{ref:"audio",refInFor:true,attrs:{"before-play":_vm.beforePlay(ind),"src":x.audio,"index":ind,"answered":_vm.question.answered && (x.selected || x.correct),"correct":x.correct,"select":_vm.selectQuestion(x)}})],1)])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"container align-items-center justify-content-end"},[_c('div',{staticClass:"margin-right-10 animation-fade"},[_c('transition',{attrs:{"name":"fade"}},[_c('gameFeedback',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFeedback),expression:"showFeedback"}],attrs:{"correct":_vm.verify(_vm.question)}})],1),_vm._v(" "),(_vm.verify(_vm.question) && _vm.question.answered)?_c('div',{staticClass:"animation-bottom animation-delay-15 bottom-alert"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(!_vm.verify(_vm.question) && _vm.question.answered)?_c('div',{staticClass:"animation-bottom animation-delay-15 bottom-alert"},[_vm._m(2)]):_vm._e()],1)]),_vm._v(" "),(!_vm.isReview)?_c('modal',{ref:"modal",attrs:{"show":_vm.showInfo,"closebtn":false,"bgcolor":"rgba(243, 243, 243, .95)"}},[_c('modalSubTopic',{attrs:{"questions":_vm.exercise.questions,"topic":_vm.topic,"subTopic":_vm.subTopic,"close":_vm.emitClose}})],1):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img container align-center"},[_c('img',{attrs:{"src":__webpack_require__(193),"width":"30","alt":"Minds"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"correct_result"},[_c('i',{staticClass:"far fa-check-circle"}),_vm._v("\n          Alternativa correta\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"wrong_result"},[_c('i',{staticClass:"far fa-times-circle"}),_vm._v("\n          Alternativa incorreta\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_subTopic__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_game_imageSelectAudio__ = __webpack_require__(1040);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    subTopicTemplate: __WEBPACK_IMPORTED_MODULE_0__components_template_subTopic__["a" /* default */],
    imageSelectAudio: __WEBPACK_IMPORTED_MODULE_1__components_game_imageSelectAudio__["a" /* default */]
  }
});

/***/ }),

/***/ 1331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('subTopicTemplate',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var topic = ref.topic;
var subTopic = ref.subTopic;
return [_c('imageSelectAudio',{attrs:{"topic":topic,"subTopic":subTopic}})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageSelectAudio_vue__ = __webpack_require__(1171);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7777d66f_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imageSelectAudio_vue__ = __webpack_require__(1331);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageSelectAudio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7777d66f_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imageSelectAudio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 640:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_firebase__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Exercise',
  data: function data() {
    return {
      firstTime: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    _topic_: 'topic/get',
    _subTopic_: 'subTopic/get',
    isReview: 'isReview',
    isEC: 'isEC',
    isSpeakUp: 'isSpeakUp',
    isSpeakUpFeedback: 'isSpeakUpFeedback',
    speakUp: 'speakup/getSpeakUp',
    subTopicSpeakUp: 'speakup/getSubTopic',
    speakUpFeedback: 'speakupFeedback/getSpeakUp',
    subTopicSpeakUpFeedback: 'speakupFeedback/getSubTopic',
    student: 'student/GET',
    teensTopic: 'teens/GET_TOPIC',
    teensSubTopic: 'teens/GET_SUBTOPIC'
  }), {
    bookTitle: function bookTitle() {
      if (!this.isSpeakUp && !this.isSpeakUpFeedback) return this.$route.params.book ? this.$route.params.book : 'Book Test';

      if (this.isSpeakUp) return this.speakUp.book_name;

      return this.speakUpFeedback.book_name;
    },
    unitTitle: function unitTitle() {
      if (!this.isSpeakUp && !this.isSpeakUpFeedback) return this.$route.params.unit ? this.$route.params.unit.toString() : '0';

      return '';
    },
    topicTitle: function topicTitle() {
      if (!this.isSpeakUp && !this.isSpeakUpFeedback) return this.$route.params.topic ? this.$route.params.topic : 'Topic Test';

      if (this.isSpeakUp) return this.speakUp.lesson_name;

      return this.speakUpFeedback.lesson_name;
    },
    topic: function topic() {
      if (!!this.student.teens) return this.teensTopic;

      if (this.isSpeakUp) return this.speakUp;

      if (this.isSpeakupFeedback) return this.speakUpFeedback;

      if (!this.isReview) return this._topic_;

      var topic = this._topic_;

      topic.finished = false;
      topic.percent = 0;
      topic.score = 0;

      return topic;
    },
    subTopic: function subTopic() {
      var _this = this;

      if (!!this.student.teens) return this.teensSubTopic;

      if (this.isSpeakUp) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.subTopicSpeakUp, {
          exercise: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.subTopicSpeakUp.exercise, {
            questions: this.subTopicSpeakUp.exercise.questions.map(function (q, index) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, q, {
                _id: String(index)
              });
            })
          })
        });
      }

      if (this.isSpeakUpFeedback) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.subTopicSpeakUpFeedback, {
          exercise: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.subTopicSpeakUpFeedback.exercise, {
            questions: this.subTopicSpeakUpFeedback.exercise.questions.map(function (q, index) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, q, {
                _id: String(index)
              });
            })
          })
        });
      }

      if (!this.isReview) return this._subTopic_;

      var topic = this.topic,
          subTopic = this._subTopic_;

      if (subTopic.type !== 'english-central') {
        subTopic.exercise.questions.forEach(function (q, index) {
          if (q.answers) {
            q.answers.forEach(function (a, ind) {
              _this.$set(subTopic.exercise.questions[index].answers[ind], 'selected', false);
              if (subTopic.exercise.questions[index].answers[ind].hasOwnProperty('pair1')) {
                _this.$delete(subTopic.exercise.questions[index].answers[ind], 'pair1');
                _this.$delete(subTopic.exercise.questions[index].answers[ind], 'pair2');
              }
            });
          }

          if (q.answer) {
            q.answer = '';
          }

          if (subTopic.exercise.questions[index].categories) {
            for (var ind in subTopic.exercise.questions[index].categories) {
              _this.$set(subTopic.exercise.questions[index].categories[ind], 'answers', null);
            }
          }

          _this.$set(subTopic.exercise.questions[index], 'hit', false);
          _this.$set(subTopic.exercise.questions[index], 'answered', false);
          if (subTopic.exercise.questions[index].score) _this.$set(subTopic.exercise.questions, 'score', 0);
          if (subTopic.exercise.questions[index].answer) _this.$set(subTopic.exercise.questions[index], 'answer', 0);
        });

        subTopic.finished = false;
        subTopic.points = 0;
      }

      return subTopic;
    }
  })
});

/***/ }),

/***/ 642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    correct: {
      type: Boolean
    },
    finish: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      showFeedback: true
    };
  }
});

/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SubTopicModal",
  props: {
    questions: {
      type: Array,
      default: Array
    },
    subTopic: {
      type: Object,
      default: Object
    },
    topic: {
      type: Object,
      default: Object
    },
    close: {
      type: Function,
      default: function _default() {
        return console.log('Close Event!');
      }
    }
  },
  computed: {
    xp: function xp() {
      return this.noDecimals(this.$store.getters['student/GET'].xp);
    },
    coins: function coins() {
      return this.noDecimals(this.$store.getters['student/GET'].coins);
    }
  },
  methods: {
    noDecimals: function noDecimals(n) {
      return parseFloat(n).toFixed(0);
    }
  }
});

/***/ }),

/***/ 644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalSubTopic_vue__ = __webpack_require__(643);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c08839c_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalSubTopic_vue__ = __webpack_require__(655);
function injectStyle (ssrContext) {
  __webpack_require__(653)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c08839c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalSubTopic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c08839c_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalSubTopic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(642);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_323ffd45_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(652);
function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-323ffd45"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_323ffd45_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subTopic_vue__ = __webpack_require__(641);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aedc01c_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subTopic_vue__ = __webpack_require__(649);
function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subTopic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aedc01c_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subTopic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(648);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("230ead99", content, true, {});

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".align-center{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@-webkit-keyframes loadAudioPlayer{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@keyframes loadAudioPlayer{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@-webkit-keyframes loadAudioPlayerReset{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}@keyframes loadAudioPlayerReset{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}.animationLoadCircle{-webkit-animation-name:loadAudioPlayer;animation-name:loadAudioPlayer;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.animationLoadCircle.reset{animation-direction:reverse;-webkit-animation-duration:.5s;animation-duration:.5s}.unit-challenge__video{-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;background:#d5d5d5;height:350px;border-radius:12px;position:relative;overflow:hidden}@media (max-width:440px){.unit-challenge__video{height:160px;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}}.unit-challenge__video .play{position:absolute;top:0;left:0;z-index:100;width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.unit-challenge__video .play_btn{-webkit-box-shadow:0 0 0 10px hsla(0,0%,100%,.3);box-shadow:0 0 0 10px hsla(0,0%,100%,.3);border-radius:50%;-webkit-transition:.3s;transition:.3s;cursor:pointer}.unit-challenge__video .play_btn:hover{-webkit-box-shadow:0 0 0 20px hsla(0,0%,100%,.3);box-shadow:0 0 0 20px hsla(0,0%,100%,.3)}.unit-challenge__video--image{-o-object-fit:cover;object-fit:cover;height:420px}.unit-challenge__video--video{-o-object-fit:cover;object-fit:cover;width:100%;height:auto}.unit-challenge__questions{-webkit-box-sizing:border-box;box-sizing:border-box;height:350px;overflow-y:auto;margin-left:20px;padding-right:20px}.unit-challenge__block{width:100%;height:100%;background:rgba(0,0,0,.8);position:absolute;top:0;left:0;z-index:999}.unit-challenge__block__center{color:#fff;width:90%;max-width:900px}.unit-challenge__block__center .icon-img{margin:20px}.unit-challenge__block__center .btn{margin:15px}@media (max-width:820px){.unit-challenge{-ms-flex-wrap:wrap;flex-wrap:wrap}.unit-challenge__questions{margin-left:0;padding-right:0;margin-top:20px;height:auto}.unit-challenge__block{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;padding-top:100px}.unit-challenge__block__center{-ms-flex-wrap:wrap;flex-wrap:wrap}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/template/subTopic.vue"],"names":[],"mappings":"AACA,cACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,mCACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,2BACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,wCACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,gCACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,qBACE,uCAAwC,AAChC,+BAAgC,AACxC,qCAAsC,AAC9B,4BAA8B,CACvC,AACD,2BACI,4BAA6B,AAC7B,+BAAgC,AACxB,sBAAwB,CACnC,AACD,uBACE,8BAA+B,AACvB,sBAAuB,AAC/B,WAAY,AACZ,mBAAoB,AACpB,aAAc,AACd,mBAAoB,AACpB,kBAAmB,AACnB,eAAiB,CAClB,AACD,yBACA,uBACM,aAAc,AACd,2BAA4B,AACxB,wBAAyB,AACrB,oBAAsB,CACnC,CACA,AACD,6BACI,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,YAAa,AACb,WAAY,AACZ,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC/B,AACD,iCACI,iDAAwD,AAChD,yCAAgD,AACxD,kBAAmB,AACnB,uBAAyB,AACzB,eAAiB,AACjB,cAAgB,CACnB,AACD,uCACM,iDAAwD,AAChD,wCAAgD,CAC7D,AACD,8BACE,oBAAqB,AAClB,iBAAkB,AACrB,YAAc,CACf,AACD,8BACE,oBAAqB,AAClB,iBAAkB,AACrB,WAAY,AACZ,WAAa,CACd,AACD,2BACE,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,gBAAiB,AACjB,iBAAkB,AAClB,kBAAoB,CACrB,AACD,uBACE,WAAY,AACZ,YAAa,AACb,0BAA+B,AAC/B,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAa,CACd,AACD,+BACE,WAAY,AACZ,UAAW,AACX,eAAiB,CAClB,AACD,yCACI,WAAa,CAChB,AACD,oCACI,WAAa,CAChB,AACD,yBACA,gBACI,mBAAoB,AAChB,cAAgB,CACvB,AACD,2BACI,cAAe,AACf,gBAAiB,AACjB,gBAAiB,AACjB,WAAa,CAChB,AACD,uBACI,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAmB,CACtB,AACD,+BACI,mBAAoB,AAChB,cAAgB,CACvB,CACA","file":"subTopic.vue","sourcesContent":["\n.align-center {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@-webkit-keyframes loadAudioPlayer {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@keyframes loadAudioPlayer {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@-webkit-keyframes loadAudioPlayerReset {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n@keyframes loadAudioPlayerReset {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n.animationLoadCircle {\n  -webkit-animation-name: loadAudioPlayer;\n          animation-name: loadAudioPlayer;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n}\n.animationLoadCircle.reset {\n    animation-direction: reverse;\n    -webkit-animation-duration: .5s;\n            animation-duration: .5s;\n}\n.unit-challenge__video {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100%;\n  background: #D5D5D5;\n  height: 350px;\n  border-radius: 12px;\n  position: relative;\n  overflow: hidden;\n}\n@media (max-width: 440px) {\n.unit-challenge__video {\n      height: 160px;\n      -webkit-box-align: baseline;\n          -ms-flex-align: baseline;\n              align-items: baseline;\n}\n}\n.unit-challenge__video .play {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    width: 100%;\n    height: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.unit-challenge__video .play_btn {\n    -webkit-box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.3);\n            box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.3);\n    border-radius: 50%;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    cursor: pointer;\n}\n.unit-challenge__video .play_btn:hover {\n      -webkit-box-shadow: 0 0 0 20px rgba(255, 255, 255, 0.3);\n              box-shadow: 0 0 0 20px rgba(255, 255, 255, 0.3);\n}\n.unit-challenge__video--image {\n  -o-object-fit: cover;\n     object-fit: cover;\n  height: 420px;\n}\n.unit-challenge__video--video {\n  -o-object-fit: cover;\n     object-fit: cover;\n  width: 100%;\n  height: auto;\n}\n.unit-challenge__questions {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 350px;\n  overflow-y: auto;\n  margin-left: 20px;\n  padding-right: 20px;\n}\n.unit-challenge__block {\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 999;\n}\n.unit-challenge__block__center {\n  color: #fff;\n  width: 90%;\n  max-width: 900px;\n}\n.unit-challenge__block__center .icon-img {\n    margin: 20px;\n}\n.unit-challenge__block__center .btn {\n    margin: 15px;\n}\n@media (max-width: 820px) {\n.unit-challenge {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.unit-challenge__questions {\n    margin-left: 0;\n    padding-right: 0;\n    margin-top: 20px;\n    height: auto;\n}\n.unit-challenge__block {\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    padding-top: 100px;\n}\n.unit-challenge__block__center {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gameHeader',{attrs:{"book":_vm.bookTitle,"unit":_vm.unitTitle,"topic":_vm.topicTitle,"description":_vm.subTopic.description}}),_vm._v(" "),_c('div',{staticClass:"yellow-line"}),_vm._v(" "),_c('div',{staticClass:"box-content shadow-box-side box-content-border box-content-border-none relative hidden gview",class:{ 'size--ec-st': _vm.isEC }},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstTime),expression:"firstTime"}],staticClass:"unit-challenge__block container wrap align-center animation-fade"},[_c('div',{staticClass:"unit-challenge__block__center container align-center animation-bottom"},[_c('div',{staticClass:"icon-img"},[_c('img',{attrs:{"src":__webpack_require__(193),"width":"80","alt":"Minds"}})]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 flex-basis-600"},[_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.")])]),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"btn btn-full btn-rounded gradient-yellow color-orange-dark",attrs:{"type":"button","name":"button"},on:{"click":function($event){_vm.firstTime = false}}},[_vm._v("INICIAR ESTUDO")])])])])]),_vm._v(" "),_vm._t("default",null,{"topic":_vm.topic,"subTopic":_vm.subTopic})],2),_vm._v(" "),_c('gameFooter',{attrs:{"questions":_vm.subTopic.type !== 'english-central' ? _vm.subTopic.exercise.questions.map(function (q, index) { return (Object.assign({}, q, {_id: String(index)})); }) : [],"length":_vm.subTopic.type !== 'english-central' ? _vm.subTopic.exercise.questions.length : 0}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(651);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("e7b3f056", content, true, {});

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".align-center[data-v-323ffd45]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@-webkit-keyframes loadAudioPlayer-data-v-323ffd45{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@keyframes loadAudioPlayer-data-v-323ffd45{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@-webkit-keyframes loadAudioPlayerReset-data-v-323ffd45{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}@keyframes loadAudioPlayerReset-data-v-323ffd45{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}.animationLoadCircle[data-v-323ffd45]{-webkit-animation-name:loadAudioPlayer-data-v-323ffd45;animation-name:loadAudioPlayer-data-v-323ffd45;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.animationLoadCircle.reset[data-v-323ffd45]{animation-direction:reverse;-webkit-animation-duration:.5s;animation-duration:.5s}.feedback-game[data-v-323ffd45]{position:absolute;top:0;left:0;width:100%;height:100%;z-index:999;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background:hsla(0,0%,100%,.9)}.feedback-game h1.correct_result[data-v-323ffd45],.feedback-game h1.wrong_result[data-v-323ffd45]{font-weight:700}.feedback-game h1.correct_result[data-v-323ffd45]{color:#5ec12d!important}.feedback-game h1.wrong_result[data-v-323ffd45]{color:#c2003c!important}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/game/feedback/index.vue"],"names":[],"mappings":"AACA,+BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,mDACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,2CACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,wDACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,gDACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,sCACE,uDAAwD,AAChD,+CAAgD,AACxD,qCAAsC,AAC9B,4BAA8B,CACvC,AACD,4CACI,4BAA6B,AAC7B,+BAAgC,AACxB,sBAAwB,CACnC,AACD,gCACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,6BAAqC,CACtC,AACD,kGACI,eAAkB,CACrB,AACD,kDACI,uBAA0B,CAC7B,AACD,gDACI,uBAA0B,CAC7B","file":"index.vue","sourcesContent":["\n.align-center[data-v-323ffd45] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@-webkit-keyframes loadAudioPlayer-data-v-323ffd45 {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@keyframes loadAudioPlayer-data-v-323ffd45 {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@-webkit-keyframes loadAudioPlayerReset-data-v-323ffd45 {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n@keyframes loadAudioPlayerReset-data-v-323ffd45 {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n.animationLoadCircle[data-v-323ffd45] {\n  -webkit-animation-name: loadAudioPlayer-data-v-323ffd45;\n          animation-name: loadAudioPlayer-data-v-323ffd45;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n}\n.animationLoadCircle.reset[data-v-323ffd45] {\n    animation-direction: reverse;\n    -webkit-animation-duration: .5s;\n            animation-duration: .5s;\n}\n.feedback-game[data-v-323ffd45] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  background: rgba(255, 255, 255, 0.9);\n}\n.feedback-game h1.correct_result[data-v-323ffd45], .feedback-game h1.wrong_result[data-v-323ffd45] {\n    font-weight: bold;\n}\n.feedback-game h1.correct_result[data-v-323ffd45] {\n    color: #5EC12D !important;\n}\n.feedback-game h1.wrong_result[data-v-323ffd45] {\n    color: #C2003C !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFeedback),expression:"showFeedback"}],staticClass:"feedback-game"},[(_vm.correct)?_c('div',[_vm._m(0)]):_c('div',[_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"correct_result container text-center align-center column"},[_c('i',{staticClass:"far fa-check-circle"}),_vm._v(" "),_c('span',[_vm._v("That's right!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"wrong_result container text-center align-center column"},[_c('i',{staticClass:"far fa-times-circle"}),_vm._v(" "),_c('span',[_vm._v("Oops! Wrong choice!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(654);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("772b6ad8", content, true, {});

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".disable[data-v-2c08839c]{-webkit-filter:grayscale(100%);filter:grayscale(100%)}.normal[data-v-2c08839c]{-webkit-filter:none;filter:none}.diplaynone[data-v-2c08839c]{display:none!important}.main--box[data-v-2c08839c]{width:100%;height:100%;border-radius:25px;padding:35px 20px;background:-webkit-gradient(linear,left bottom,left top,from(#764ba2),to(#667eea));background:linear-gradient(0deg,#764ba2,#667eea)}.main--box .card--score[data-v-2c08839c]{width:405px;height:100%;border-radius:30px;padding:20px;background:-webkit-gradient(linear,left top,left bottom,from(#ebce00),to(#ff5700));background:linear-gradient(#ebce00,#ff5700);-webkit-box-shadow:11px 15px 14px rgba(0,0,0,.16);box-shadow:11px 15px 14px rgba(0,0,0,.16);-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.main--box .card--score__box[data-v-2c08839c]{width:100%;height:100%;border-radius:20px;background:#fff}.main--box .card--score__box___msg[data-v-2c08839c]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:45%;flex-basis:45%;padding:0 20px;line-height:28px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.main--box .card--score__box___msg p[data-v-2c08839c]{color:#7450a9;font-size:30px;text-align:end}.main--box .card--score__box___msg_stars[data-v-2c08839c]{text-align:end}.main--box .card--score__box___msg_stars img[data-v-2c08839c]{width:20px}.main--box .card--score__box___scoreNumber[data-v-2c08839c]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:55%;flex-basis:55%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:0 20px 0 0}.main--box .card--score__box___scoreNumber__scoreGreen[data-v-2c08839c]{color:#09a57e;font-size:80px;text-align:center}.main--box .card--score__box___scoreNumber__scoreRed[data-v-2c08839c]{color:#c71a32;font-size:80px;text-align:center}.main--box .card--score__box___scoreNumber span[data-v-2c08839c]{background:#7450a9;margin:5px 10px 12px;color:#fff;font-size:13px;font-weight:300;border-radius:300px;display:-webkit-box;display:-ms-flexbox;display:flex;height:20px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.main--box .extraScore__base[data-v-2c08839c]{background:#fff;font-size:13px;width:100%;padding:10px;border-radius:15px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:50%;flex-basis:50%;text-align:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.main--box .extraScore__base___xp[data-v-2c08839c]{background:#3087f7;border-radius:300px;padding:5px 10px;color:#fff!important;margin:0 5px;letter-spacing:1px}.main--box .extraScore__base___coin[data-v-2c08839c]{background:#bc8401;border-radius:300px;padding:5px 10px;color:#fff!important;margin:0 5px;letter-spacing:1px}.main--box .extraScore #xp[data-v-2c08839c]{margin:15px 10px 0 0;color:#3087f7}.main--box .extraScore #coin[data-v-2c08839c]{margin:15px 0 0 10px;color:#bc8401}.main--box .card--info[data-v-2c08839c]{margin-left:30px;max-width:480px}.main--box .card--info__feed[data-v-2c08839c]{font-size:70px;color:#57ffd4;text-transform:uppercase}.main--box .card--info__feed___ops[data-v-2c08839c]{color:#ffbec7!important;font-size:70px;text-transform:uppercase}.main--box .card--info__msgFeed[data-v-2c08839c]{font-size:18px;font-weight:400;margin-top:0;color:#a5e4ff}.main--box .card--info__textFeed[data-v-2c08839c]{font-size:15px;font-weight:200;margin-top:0}.main--box .card--info__progressUnit[data-v-2c08839c]{font-size:13px;font-weight:200;margin-top:38px;text-transform:uppercase;border:2px solid #fff;padding:10px;border-radius:300px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.main--box .card--info__progressUnit___barBG[data-v-2c08839c]{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#fff),color-stop(105%,#6976df));background:linear-gradient(-90deg,#fff 50%,#6976df 105%);height:15px;width:100%;border-radius:300px;margin:0 0 0 10px;overflow:hidden}.main--box .card--info__progressUnit___barScore[data-v-2c08839c]{background:-webkit-gradient(linear,right top,left top,from(#22ffeb),to(#677ce7));background:linear-gradient(-90deg,#22ffeb,#677ce7);height:16px;border-radius:300px;width:80.63px}.main--box .card--info__progressUnit___percent[data-v-2c08839c]{background:#fff;color:#56308f;padding:5px 10px;font-size:15px;border-radius:300px;margin-left:10px;font-weight:400}.main--box .card--info a[data-v-2c08839c]{background:-webkit-gradient(linear,left bottom,left top,from(#ff9100),color-stop(150%,#df0));background:linear-gradient(0deg,#ff9100,#df0 150%);border-radius:300px;margin-top:10px;color:#653600;font-weight:400}.main--box .card--info a .iconbtn[data-v-2c08839c]{margin:0 0 0 10px}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/modal/modalSubTopic.vue"],"names":[],"mappings":"AACA,0BACE,+BAAgC,AACxB,sBAAwB,CACjC,AACD,yBACE,oBAAqB,AACb,WAAa,CACtB,AACD,6BACE,sBAAyB,CAC1B,AACD,4BACE,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,kBAAmB,AACnB,mFAAwF,AACxF,gDAA4D,CAC7D,AACD,yCACI,YAAa,AACb,YAAa,AACb,mBAAoB,AACpB,aAAc,AACd,mFAAwF,AACxF,4CAAsD,AACtD,kDAAuD,AAC/C,0CAA+C,AACvD,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,AACD,8CACM,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,eAAkB,CACvB,AACD,oDACQ,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,4BAA6B,AACzB,eAAgB,AACpB,eAA2B,AAC3B,iBAAkB,AAClB,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CACtC,AACD,sDACU,cAAe,AACf,eAAgB,AAChB,cAAgB,CACzB,AACD,0DACU,cAAgB,CACzB,AACD,8DACY,UAAY,CACvB,AACD,4DACQ,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,4BAA6B,AACzB,eAAgB,AACpB,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,kBAA0B,CACjC,AACD,wEACU,cAAe,AACf,eAAgB,AAChB,iBAAmB,CAC5B,AACD,sEACU,cAAe,AACf,eAAgB,AAChB,iBAAmB,CAC5B,AACD,iEACU,mBAAoB,AACpB,qBAA2B,AAC3B,WAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACzC,AACD,8CACI,gBAAkB,AAClB,eAAgB,AAChB,WAAY,AACZ,aAAc,AACd,mBAAoB,AACpB,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,4BAA6B,AACzB,eAAgB,AACpB,kBAAmB,AACnB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,8BAA+B,AAC3B,2BAA4B,AACxB,4BAA8B,CACzC,AACD,mDACM,mBAAoB,AACpB,oBAAqB,AACrB,iBAAkB,AAClB,qBAAwB,AACxB,aAAgB,AAChB,kBAAoB,CACzB,AACD,qDACM,mBAAoB,AACpB,oBAAqB,AACrB,iBAAkB,AAClB,qBAAwB,AACxB,aAAgB,AAChB,kBAAoB,CACzB,AACD,4CACI,qBAA0B,AAC1B,aAAe,CAClB,AACD,8CACI,qBAA0B,AAC1B,aAAe,CAClB,AACD,wCACI,iBAAkB,AAClB,eAAiB,CACpB,AACD,8CACM,eAAgB,AAChB,cAAe,AACf,wBAA0B,CAC/B,AACD,oDACQ,wBAA0B,AAC1B,eAAgB,AAChB,wBAA0B,CACjC,AACD,iDACM,eAAgB,AAChB,gBAAiB,AACjB,aAAgB,AAChB,aAAe,CACpB,AACD,kDACM,eAAgB,AAChB,gBAAiB,AACjB,YAAgB,CACrB,AACD,sDACM,eAAgB,AAChB,gBAAiB,AACjB,gBAAiB,AACjB,yBAA0B,AAC1B,sBAAwB,AACxB,aAAc,AACd,oBAAqB,AACrB,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACjC,AACD,8DACQ,qGAA4G,AAC5G,yDAA4D,AAC5D,YAAa,AACb,WAAY,AACZ,oBAAqB,AACrB,kBAAyB,AACzB,eAAiB,CACxB,AACD,iEACQ,iFAAsF,AACtF,mDAA8D,AAC9D,YAAa,AACb,oBAAqB,AACrB,aAAe,CACtB,AACD,gEACQ,gBAAkB,AAClB,cAAe,AACf,iBAAkB,AAClB,eAAgB,AAChB,oBAAqB,AACrB,iBAAkB,AAClB,eAAiB,CACxB,AACD,0CACM,6FAAmG,AACnG,mDAAyD,AACzD,oBAAqB,AACrB,gBAAiB,AACjB,cAAe,AACf,eAAiB,CACtB,AACD,mDACQ,iBAAyB,CAChC","file":"modalSubTopic.vue","sourcesContent":["\n.disable[data-v-2c08839c] {\n  -webkit-filter: grayscale(100%);\n          filter: grayscale(100%);\n}\n.normal[data-v-2c08839c] {\n  -webkit-filter: none;\n          filter: none;\n}\n.diplaynone[data-v-2c08839c] {\n  display: none !important;\n}\n.main--box[data-v-2c08839c] {\n  width: 100%;\n  height: 100%;\n  border-radius: 25px;\n  padding: 35px 20px;\n  background: -webkit-gradient(linear, left bottom, left top, from(#764ba2), to(#667eea));\n  background: linear-gradient(0deg, #764ba2 0%, #667eea 100%);\n}\n.main--box .card--score[data-v-2c08839c] {\n    width: 405px;\n    height: 100%;\n    border-radius: 30px;\n    padding: 20px;\n    background: -webkit-gradient(linear, left top, left bottom, from(#ebce00), to(#ff5700));\n    background: linear-gradient(#ebce00 0%, #ff5700 100%);\n    -webkit-box-shadow: 11px 15px 14px rgba(0, 0, 0, 0.16);\n            box-shadow: 11px 15px 14px rgba(0, 0, 0, 0.16);\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.main--box .card--score__box[data-v-2c08839c] {\n      width: 100%;\n      height: 100%;\n      border-radius: 20px;\n      background: white;\n}\n.main--box .card--score__box___msg[data-v-2c08839c] {\n        -webkit-box-flex: 1;\n            -ms-flex-positive: 1;\n                flex-grow: 1;\n        -ms-flex-preferred-size: 45%;\n            flex-basis: 45%;\n        padding: 0px 20px 0px 20px;\n        line-height: 28px;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n}\n.main--box .card--score__box___msg p[data-v-2c08839c] {\n          color: #7450A9;\n          font-size: 30px;\n          text-align: end;\n}\n.main--box .card--score__box___msg_stars[data-v-2c08839c] {\n          text-align: end;\n}\n.main--box .card--score__box___msg_stars img[data-v-2c08839c] {\n            width: 20px;\n}\n.main--box .card--score__box___scoreNumber[data-v-2c08839c] {\n        -webkit-box-flex: 1;\n            -ms-flex-positive: 1;\n                flex-grow: 1;\n        -ms-flex-preferred-size: 55%;\n            flex-basis: 55%;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        padding: 0px 20px 0px 0px;\n}\n.main--box .card--score__box___scoreNumber__scoreGreen[data-v-2c08839c] {\n          color: #09A57E;\n          font-size: 80px;\n          text-align: center;\n}\n.main--box .card--score__box___scoreNumber__scoreRed[data-v-2c08839c] {\n          color: #C71A32;\n          font-size: 80px;\n          text-align: center;\n}\n.main--box .card--score__box___scoreNumber span[data-v-2c08839c] {\n          background: #7450A9;\n          margin: 5px 10px 12px 10px;\n          color: white;\n          font-size: 13px;\n          font-weight: 300;\n          border-radius: 300px;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          height: 20px;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n}\n.main--box .extraScore__base[data-v-2c08839c] {\n    background: white;\n    font-size: 13px;\n    width: 100%;\n    padding: 10px;\n    border-radius: 15px;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -ms-flex-preferred-size: 50%;\n        flex-basis: 50%;\n    text-align: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: space-evenly;\n        -ms-flex-pack: space-evenly;\n            justify-content: space-evenly;\n}\n.main--box .extraScore__base___xp[data-v-2c08839c] {\n      background: #3087F7;\n      border-radius: 300px;\n      padding: 5px 10px;\n      color: white !important;\n      margin: 0px 5px;\n      letter-spacing: 1px;\n}\n.main--box .extraScore__base___coin[data-v-2c08839c] {\n      background: #BC8401;\n      border-radius: 300px;\n      padding: 5px 10px;\n      color: white !important;\n      margin: 0px 5px;\n      letter-spacing: 1px;\n}\n.main--box .extraScore #xp[data-v-2c08839c] {\n    margin: 15px 10px 0px 0px;\n    color: #3087F7;\n}\n.main--box .extraScore #coin[data-v-2c08839c] {\n    margin: 15px 0px 0px 10px;\n    color: #BC8401;\n}\n.main--box .card--info[data-v-2c08839c] {\n    margin-left: 30px;\n    max-width: 480px;\n}\n.main--box .card--info__feed[data-v-2c08839c] {\n      font-size: 70px;\n      color: #57FFD4;\n      text-transform: uppercase;\n}\n.main--box .card--info__feed___ops[data-v-2c08839c] {\n        color: #FFBEC7 !important;\n        font-size: 70px;\n        text-transform: uppercase;\n}\n.main--box .card--info__msgFeed[data-v-2c08839c] {\n      font-size: 18px;\n      font-weight: 400;\n      margin-top: 0px;\n      color: #A5E4FF;\n}\n.main--box .card--info__textFeed[data-v-2c08839c] {\n      font-size: 15px;\n      font-weight: 200;\n      margin-top: 0px;\n}\n.main--box .card--info__progressUnit[data-v-2c08839c] {\n      font-size: 13px;\n      font-weight: 200;\n      margin-top: 38px;\n      text-transform: uppercase;\n      border: 2px solid white;\n      padding: 10px;\n      border-radius: 300px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.main--box .card--info__progressUnit___barBG[data-v-2c08839c] {\n        background: -webkit-gradient(linear, right top, left top, color-stop(50%, #fff), color-stop(105%, #6976df));\n        background: linear-gradient(-90deg, #fff 50%, #6976df 105%);\n        height: 15px;\n        width: 100%;\n        border-radius: 300px;\n        margin: 0px 0px 0px 10px;\n        overflow: hidden;\n}\n.main--box .card--info__progressUnit___barScore[data-v-2c08839c] {\n        background: -webkit-gradient(linear, right top, left top, from(#22ffeb), to(#677ce7));\n        background: linear-gradient(-90deg, #22ffeb 0%, #677ce7 100%);\n        height: 16px;\n        border-radius: 300px;\n        width: 80.63px;\n}\n.main--box .card--info__progressUnit___percent[data-v-2c08839c] {\n        background: white;\n        color: #56308F;\n        padding: 5px 10px;\n        font-size: 15px;\n        border-radius: 300px;\n        margin-left: 10px;\n        font-weight: 400;\n}\n.main--box .card--info a[data-v-2c08839c] {\n      background: -webkit-gradient(linear, left bottom, left top, from(#ff9100), color-stop(150%, #df0));\n      background: linear-gradient(0deg, #ff9100 0%, #df0 150%);\n      border-radius: 300px;\n      margin-top: 10px;\n      color: #653600;\n      font-weight: 400;\n}\n.main--box .card--info a .iconbtn[data-v-2c08839c] {\n        margin: 0px 0px 0px 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main--box container justify-content-center align-item-center wrap"},[_c('div',{staticClass:"card--score container"},[_c('div',{staticClass:"card--score__box container justify-content-center align-item-center"},[_c('div',{staticClass:"card--score__box___msg container justify-content-center"},[_c('p',[_vm._v("YOUR PARTIAL SCORE")]),_vm._v(" "),_c('div',{staticClass:"card--score__box___msg_stars"},[_c('img',{staticClass:"disable",class:{ normal : _vm.subTopic.points >= 20},attrs:{"src":__webpack_require__(640),"alt":"star"}}),_vm._v(" "),_c('img',{staticClass:"disable",class:{ normal : _vm.subTopic.points >= 40},attrs:{"src":__webpack_require__(640),"alt":"star"}}),_vm._v(" "),_c('img',{staticClass:"disable",class:{ normal : _vm.subTopic.points >= 51},attrs:{"src":__webpack_require__(640),"alt":"star"}}),_vm._v(" "),_c('img',{staticClass:"disable",class:{ normal : _vm.subTopic.points >= 75},attrs:{"src":__webpack_require__(640),"alt":"star"}}),_vm._v(" "),_c('img',{staticClass:"disable",class:{ normal : _vm.subTopic.points == 100},attrs:{"src":__webpack_require__(640),"alt":"star"}})])]),_vm._v(" "),(parseFloat(_vm.subTopic.points) >= 70)?_c('div',{staticClass:"card--score__box___scoreNumber card--score__box___scoreNumber__scoreGreen container justify-content-center"},[_c('p',[_vm._v(_vm._s(parseFloat(_vm.subTopic.points).toFixed(1)))]),_vm._v(" "),_c('span',[_vm._v("POINTS")])]):_c('div',{staticClass:"card--score__box___scoreNumber card--score__box___scoreNumber__scoreRed container justify-content-center"},[_c('p',[_vm._v(_vm._s(parseFloat(_vm.subTopic.points).toFixed(1)))]),_vm._v(" "),_c('span',[_vm._v("POINTS")])])]),_vm._v(" "),(!_vm.topic.speakup)?_c('div',{staticClass:"extraScore container"},[_c('div',{staticClass:"extraScore__base container",attrs:{"id":"xp"}},[_vm._v("EXPERIENCE "),_c('span',{staticClass:"extraScore__base___xp"},[_vm._v(_vm._s(parseInt(_vm.xp)))])]),_vm._v(" "),_c('div',{staticClass:"extraScore__base container",attrs:{"id":"coin"}},[_vm._v("MDSCASH "),_c('span',{staticClass:"extraScore__base___coin"},[_vm._v(_vm._s(_vm.coins ? _vm.coins : 0))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card--info container column"},[(_vm.subTopic.points >= 70)?_c('div',[_c('p',{staticClass:"card--info__feed"},[_vm._v("Very Well!")]),_vm._v(" "),_c('p',{staticClass:"card--info__msgFeed"},[_vm._v("You did great performance in these exercises.")]),_vm._v(" "),_c('p',{staticClass:"card--info__textFeed"},[_vm._v("Voce esta indo muito bem continue assim para aproveitar ao máximo o aprendizado de inglês!")])]):_c('div',[_c('p',{staticClass:"card--info__feed___ops"},[_vm._v("OOPSS!")]),_vm._v(" "),_c('p',{staticClass:"card--info__msgFeed"},[_vm._v("You had below-average performance.")]),_vm._v(" "),_c('p',{staticClass:"card--info__textFeed"},[_vm._v("Voce nao foi tao bem nestes exercicios, clique no  botao abaixo e revise seus erros!")])]),_vm._v(" "),_c('div',{staticClass:"card--info__progressUnit container justify-content-between"},[_c('span',{staticStyle:{"flex-grow":"2","flex-basis":"500px"}},[_vm._v("Progress of "+_vm._s(_vm.topic.title || _vm.topic.lesson_name))]),_vm._v(" "),_c('div',{staticClass:"card--info__progressUnit___barBG"},[_c('div',{staticClass:"card--info__progressUnit___barScore",style:({ width: ((_vm.topic.percent) + "%") })})]),_vm._v(" "),_c('span',{staticClass:"card--info__progressUnit___percent"},[_vm._v(_vm._s(_vm.noDecimals(_vm.topic.percent))+"%")])]),_vm._v(" "),_c('a',{staticClass:"btn btn-full",attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.close()}}},[_vm._v("\n        SEE MY ANSWERS\n        "),_vm._v(" "),_c('i',{staticClass:"iconbtn fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_game_feedback__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modal__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modal_modalBus__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modal_modalSubTopic__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_game_gameBus__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GameComponents_audio_player_select_audio__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__(82);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    gameFeedback: __WEBPACK_IMPORTED_MODULE_6__components_game_feedback__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_7__components_modal__["a" /* default */],
    modalSubTopic: __WEBPACK_IMPORTED_MODULE_9__components_modal_modalSubTopic__["a" /* default */],
    audioPlayerSelectAudio: __WEBPACK_IMPORTED_MODULE_11__GameComponents_audio_player_select_audio__["a" /* default */]
  },
  data: function data() {
    return {
      selectedQuestion: null,
      finish: false,
      showFeedback: false,
      clicks: 0,
      question: {},
      ended: false,
      index: 0,
      showInfo: false
    };
  },

  props: {
    topic: {
      type: Object,
      default: function _default() {
        return new Object();
      }
    },
    subTopic: {
      type: Object,
      default: function _default() {
        return new Object();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_13_vuex__["c" /* mapGetters */])({
    testMode: "isTestMode",
    isReview: "isReview",
    isSpeakUp: 'isSpeakUp',
    student: 'student/GET'
  }), {
    exercise: function exercise() {
      return this.subTopic.exercise;
    }
  }),
  methods: {
    selectQuestion: function selectQuestion(answer) {
      var _this = this;

      return function () {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (_this.question.answered) {
                      _context.next = 9;
                      break;
                    }

                    answer.selected = true;
                    _this.question.answered = true;
                    if (answer.correct) _this.question.hit = true;else _this.question.hit = false;
                    _this.$set(_this.exercise.questions, _this.index, _this.question);
                    _this.feedback();
                    _context.next = 8;
                    return _this.save(_this.question);

                  case 8:
                    resolve();

                  case 9:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      };
    },
    feedback: function feedback() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.showFeedback = true;
                _context2.next = 3;
                return _this2.$delay(1500);

              case 3:
                _this2.showFeedback = false;
                __WEBPACK_IMPORTED_MODULE_10__components_game_gameBus__["a" /* default */].$emit("setEnabled", true);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    verify: function verify(question) {
      if (question.answers) {
        var correctIndex = question.answers.findIndex(function (x) {
          return x.correct;
        });
        if (question.answers[correctIndex].selected) return true;
      }
      return false;
    },
    setCurrent: function setCurrent() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var qst, currentIndex, questions, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                qst = {}, currentIndex = 0;
                questions = _this3.exercise.questions;
                _context3.t0 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.keys(questions);

              case 3:
                if ((_context3.t1 = _context3.t0()).done) {
                  _context3.next = 12;
                  break;
                }

                index = _context3.t1.value;

                currentIndex = index;

                if (questions[index].answered) {
                  _context3.next = 9;
                  break;
                }

                qst = questions[index];
                return _context3.abrupt("break", 12);

              case 9:
                if (parseInt(index) == questions.length - 1) {
                  qst = questions[index];
                  _this3.ended = true;
                }
                _context3.next = 3;
                break;

              case 12:
                _this3.index = currentIndex;
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this3.question).length == 0 || qst._id !== _this3.question._id) {
                  if (!qst.answered) qst.answers = _this3.$shuffle(qst.answers);
                  _this3.$set(_this3, "question", qst);
                }
                _this3.resetAudios();

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_10__components_game_gameBus__["a" /* default */].$emit("setEnabled", _this3.question.answered);
                }, 1000);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    save: function save(question) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var copy, scoreQuestions, answered, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _qst, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, aswr, score, payload;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                copy = Object(__WEBPACK_IMPORTED_MODULE_12_lodash__["cloneDeep"])(question);
                scoreQuestions = 0;
                answered = 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 6;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this4.exercise.questions);

              case 8:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 33;
                  break;
                }

                _qst = _step.value;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 13;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_qst.answers); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  aswr = _step2.value;

                  if (aswr.selected && aswr.correct) scoreQuestions++;
                }

                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](13);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 21:
                _context4.prev = 21;
                _context4.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context4.prev = 24;

                if (!_didIteratorError2) {
                  _context4.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context4.finish(24);

              case 28:
                return _context4.finish(21);

              case 29:
                if (_qst.answered) answered++;

              case 30:
                _iteratorNormalCompletion = true;
                _context4.next = 8;
                break;

              case 33:
                _context4.next = 39;
                break;

              case 35:
                _context4.prev = 35;
                _context4.t1 = _context4["catch"](6);
                _didIteratorError = true;
                _iteratorError = _context4.t1;

              case 39:
                _context4.prev = 39;
                _context4.prev = 40;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 42:
                _context4.prev = 42;

                if (!_didIteratorError) {
                  _context4.next = 45;
                  break;
                }

                throw _iteratorError;

              case 45:
                return _context4.finish(42);

              case 46:
                return _context4.finish(39);

              case 47:
                score = scoreQuestions * 100 / _this4.exercise.questions.length;
                payload = {
                  points: score,
                  finished: false,
                  question: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, copy)
                };

                if (!(answered == _this4.exercise.questions.length)) {
                  _context4.next = 55;
                  break;
                }

                payload.finished = true;
                _this4.ended = true;
                _context4.next = 54;
                return _this4.$delay(1500);

              case 54:
                _this4.showInfo = true;

              case 55:

                __WEBPACK_IMPORTED_MODULE_10__components_game_gameBus__["a" /* default */].$emit("updateProgress", score);

                if (!_this4.student.teens) {
                  _context4.next = 60;
                  break;
                }

                _context4.next = 59;
                return _this4.$store.dispatch('teens/answerQuestion', payload);

              case 59:
                return _context4.abrupt("return");

              case 60:
                if (!_this4.isSpeakUp) {
                  _context4.next = 64;
                  break;
                }

                _context4.next = 63;
                return _this4.$store.dispatch("speakup/answerQuestion", __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this4.$route.params, payload));

              case 63:
                return _context4.abrupt("return");

              case 64:
                if (!(!_this4.testMode && !_this4.isReview)) {
                  _context4.next = 67;
                  break;
                }

                _context4.next = 67;
                return _this4.$store.dispatch("subTopic/answerQuestion", payload);

              case 67:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[6, 35, 39, 47], [13, 17, 21, 29], [22,, 24, 28], [40,, 42, 46]]);
      }))();
    },
    closeModal: function closeModal() {
      this.showInfo = false;
    },
    emitClose: function emitClose() {
      this.$refs["modal"].close();
    },
    viewQuestion: function viewQuestion(index) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var question;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                question = _this5.exercise.questions[index];

                if (question && question.answered) {
                  _this5.index = index;
                  _this5.$set(_this5, "question", question);
                }

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    beforePlay: function beforePlay(index) {
      var _this6 = this;

      return function () {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
          var audios = _this6.$refs['audio'];
          if (audios) {
            for (var ind in audios) {
              if (ind != index) audios[ind].pause();
            }
          }
          resolve();
        });
      };
    },
    resetAudios: function resetAudios() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var audios, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, audio;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this7.$delay(500);

              case 2:
                audios = _this7.$refs['audio'];
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context6.prev = 6;

                for (_iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(audios); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  audio = _step3.value;

                  audio.setInitialValues();
                }
                _context6.next = 14;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](6);
                _didIteratorError3 = true;
                _iteratorError3 = _context6.t0;

              case 14:
                _context6.prev = 14;
                _context6.prev = 15;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 17:
                _context6.prev = 17;

                if (!_didIteratorError3) {
                  _context6.next = 20;
                  break;
                }

                throw _iteratorError3;

              case 20:
                return _context6.finish(17);

              case 21:
                return _context6.finish(14);

              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[6, 10, 14, 22], [15,, 17, 21]]);
      }))();
    }
  },
  watch: {
    ended: function ended(val) {
      __WEBPACK_IMPORTED_MODULE_10__components_game_gameBus__["a" /* default */].$emit("setEnded", val);
    },
    index: function index(val) {
      __WEBPACK_IMPORTED_MODULE_10__components_game_gameBus__["a" /* default */].$emit("updateIndex", val);
    }
  },
  mounted: function mounted() {
    this.setCurrent();
    __WEBPACK_IMPORTED_MODULE_10__components_game_gameBus__["a" /* default */].$on("viewQuestion", this.viewQuestion);

    __WEBPACK_IMPORTED_MODULE_10__components_game_gameBus__["a" /* default */].$emit("updateProgress", this.subTopic.points);
    __WEBPACK_IMPORTED_MODULE_8__components_modal_modalBus__["a" /* default */].$on("close", this.closeModal);
    __WEBPACK_IMPORTED_MODULE_10__components_game_gameBus__["a" /* default */].$on("setCurrent", this.setCurrent);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_10__components_game_gameBus__["a" /* default */].$off("viewQuestion", this.viewQuestion);

    __WEBPACK_IMPORTED_MODULE_8__components_modal_modalBus__["a" /* default */].$off("close", this.closeModal);
    __WEBPACK_IMPORTED_MODULE_10__components_game_gameBus__["a" /* default */].$off("setCurrent", this.setCurrent);
  }
});

/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "audio-player",
  data: function data() {
    return {
      playing: false,
      canplay: false,
      duration: 0,
      currentTime: 0,
      ended: false,
      clicked: false,
      reseting: false
    };
  },

  props: {
    src: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 0
    },
    beforePlay: {
      type: Function,
      default: function _default() {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
          return resolve();
        });
      }
    },
    answered: {
      type: Boolean,
      default: false
    },
    correct: {
      type: Boolean,
      default: false
    },
    select: {
      type: Function,
      default: function _default() {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
          return resolve();
        });
      }
    }
  },
  computed: {
    progress: function progress() {
      if (!this.canplay) return 0;
      if (this.ended) return 100;
      var percent = this.currentTime * 100 / this.duration;
      return percent > 100 ? 100 : percent;
    },
    minutes: function minutes() {
      if (!this.duration) return 0;
      var minutes = parseInt((this.duration - this.currentTime) / 60, 10);
      return minutes > 9 ? minutes : "0" + (!minutes ? 0 : minutes);
    },
    seconds: function seconds() {
      if (!this.duration) return 0;
      var seconds = parseInt((this.duration - this.currentTime) % 60);
      return seconds > 9 ? seconds : "0" + (!seconds ? 0 : seconds);
    }
  },
  methods: {
    play: function play() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this.clicked && !_this.reseting)) {
                  _context.next = 6;
                  break;
                }

                if (!_this.canplay) {
                  _context.next = 6;
                  break;
                }

                if (_this.playing) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return _this.beforePlay();

              case 5:
                _this.$refs["player"].play();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    pause: function pause() {
      if (!this.clicked && !this.reseting) {
        if (this.canplay) {
          if (this.playing) {
            this.$refs["player"].pause();
          }
        }
      }
    },
    toogle: function toogle() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this2.clicked && !_this2.reseting)) {
                  _context2.next = 14;
                  break;
                }

                if (!_this2.ended) {
                  _context2.next = 6;
                  break;
                }

                _this2.$refs["player"].currentTime = 0;
                _context2.next = 5;
                return _this2.$delay(300);

              case 5:
                _this2.ended = false;

              case 6:
                if (!_this2.canplay) {
                  _context2.next = 14;
                  break;
                }

                if (!_this2.playing) {
                  _context2.next = 11;
                  break;
                }

                _this2.$refs["player"].pause();
                _context2.next = 14;
                break;

              case 11:
                _context2.next = 13;
                return _this2.beforePlay();

              case 13:
                _this2.$refs["player"].play();

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    reset: function reset() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!_this3.reseting && !_this3.clicked)) {
                  _context3.next = 12;
                  break;
                }

                _this3.ended = true;
                _this3.$refs["player"].pause();
                _context3.next = 5;
                return _this3.$delay(10);

              case 5:
                _this3.$refs["player"].currentTime = 0;
                _context3.next = 8;
                return _this3.$delay(300);

              case 8:
                _this3.ended = false;
                _context3.next = 11;
                return _this3.beforePlay();

              case 11:
                _this3.$refs["player"].play();

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    loaded: function loaded(audio) {
      this.duration = audio.duration;
      this.canplay = true;
      this.setInitialValues();
    },
    timeChanged: function timeChanged(time) {
      this.currentTime = time;
    },
    setInitialValues: function setInitialValues() {
      this.$refs["player"].pause();
      this.playing = false;
      this.$refs["player"].currentTime = 0;
      this.currentTime = 0;
    }
  },
  watch: {
    src: function src() {
      this.setInitialValues();
      this.canplay = false;
      this.duration = 0;
      this.$refs["player"].load();
    }
  },
  mounted: function mounted() {
    this.$refs["player"].load();
    this.setInitialValues();
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.b213280d8e9bc1f90bf8.js